// The rules the Angular content-item-image-upload directive applied before it uploaded anything.
// The server accepts far larger files (S3Asset allows 11 MB), so this limit is the editor's own.
export const MAX_IMAGE_SIZE_MB = 2.5;

export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/svg+xml', 'image/gif', 'image/webp'];

const DUPLICATE_FILE_NAME_MESSAGE = 'You cannot upload two files with the same name at once.';

// Returns the messages to show, or an empty list when every file is acceptable. A duplicate name
// short-circuits, because the upload matches an asset back to its file by name.
export function validateImageFiles(files: File[]): string[] {
    const names = files.map(file => file.name);
    if (new Set(names).size < names.length) return [DUPLICATE_FILE_NAME_MESSAGE];

    return files.flatMap(file => {
        const messages: string[] = [];

        // The wording leaves webp out, although webp is accepted. Kept as it was rather than
        // rewritten with the conversion.
        if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
            messages.push(`'${file.name}' is not an allowed image type (jpg, png, gif, and svg are allowed).`);
        }

        if (file.size > MAX_IMAGE_SIZE_MB * 1024 * 1024) {
            messages.push(`'${file.name}' exceeds the maximum upload size of ${MAX_IMAGE_SIZE_MB} MB`);
        }

        return messages;
    });
}
